import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import qs from 'qs';

import Hero from '../Components/Hero/Hero.js';
import PageBuilder from '../Components/PageBuilder.js';
import { useLocaleContext } from '../core/context/localeContext';
import useLoader from '../core/hooks/useLoader.js';

const BASE_URL =
    process.env.REACT_APP_BASE_URL || 'https://www.sleepercharger.com';

function ContactPage(props) {
    const [page, setPage] = useState();
    const { locale, urlPrefix } = useLocaleContext();
    const navigate = useNavigate();
    useLoader(page);

    useEffect(() => {
        const getFaqItems = async () => {
            const query = qs.stringify(
                {
                    locale: locale,
                    populate: {
                        hero: {
                            populate: ['image', 'imageMobile'],
                        },
                        builder: {
                            populate: '*',
                        },
                        pageMeta: {
                            populate: '*',
                        },
                    },
                },
                {
                    encodeValuesOnly: true, // prettify URL
                }
            );
            await axios
                .get(`${process.env.REACT_APP_API_URL}/api/contact?${query}`, {
                    headers: {
                        Authorization: process.env.REACT_APP_API_KEY,
                    },
                })
                .then((res) => {
                    setPage(res.data.data.attributes);
                })
                .catch(() => {
                    setPage(null);
                    navigate(`${urlPrefix}/`, { replace: true });
                });
        };

        if (locale) getFaqItems();
    }, [locale, navigate, urlPrefix]);

    return (
        <>
            {page && (
                <>
                    <Helmet>
                        <title>
                            {page?.pageMeta?.title || 'Contact'} |
                            SleeperCharger
                        </title>
                        <meta
                            name="description"
                            content={
                                page?.pageMeta?.description ||
                                'Hotel with guaranteed electric vehicle chargers. Book now only at SleeperCharger.'
                            }
                        />
                        <link
                            rel="canonical"
                            href={
                                page?.pageMeta?.canonical ||
                                `${BASE_URL}${
                                    locale !== 'en' ? `/${locale}` : ''
                                }/contact`
                            }
                        />
                    </Helmet>
                    {page.hero && (
                        <Hero data={page.hero} isMobile={props.isMobile} />
                    )}
                    {page.builder.length && (
                        <PageBuilder blocks={page.builder} />
                    )}
                </>
            )}
        </>
    );
}

export default ContactPage;
